<template>
    <v-flex xs12 class="group_banner">
        <v-layout row wrap>
        <v-flex xs12 sm8>
        <Breadcrumb></Breadcrumb>
        <v-flex class="community_title" v-if="hasCommunityIdInRoute">
            <v-flex class="community_title__name" data-qe-id="GroupBanner_CommunityName">{{communityName}}</v-flex>
        </v-flex>
        </v-flex>
        <v-flex xs12 sm4 class="banner_view__options">
        <admin-view-option v-if="isCommunityAdmin || isSuperAdmin">
        </admin-view-option>
        <manage-community-options class="more-actions"
            :displayInviteSomeone="isExistGroup && currentCommunityView !== userRoles.ADMIN"
            :displayJoin="!isExistGroup && hasCommunityIdInRoute"
            :displayResign="isExistGroup && currentCommunityView !== userRoles.ADMIN"
            :communityCategory="communityCategory"
            :enrollmentType="enrollmentType"></manage-community-options>
        </v-flex>
        </v-layout>

    </v-flex>
</template>

<script>
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import AdminViewOption from '../AdminViewOption/AdminViewOption';
    import ManageCommunityOptions from '../ManageCommunityOptions/ManageCommunityOptions';
    import { userRoles } from "../appCommon.constants";
    import Breadcrumb from "../Layout/Breadcrumb";

    export default {
        name: 'GroupBanner',
        components: {
            AdminViewOption,
            ManageCommunityOptions,
            Breadcrumb,
        },
        created() {},
        data: () => ({
            userRoles,
        }),
        methods: {},
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                currentCommunityView: `${[storeGetters.currentCommunityView]}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
                userPermissionsData: `auth/${storeGetters.permissionsData}`,
            }),
            isSuperAdmin() {
                return this.communityInfo && this.communityInfo.roles
                    && this.communityInfo.roles.some(o => o === "Group Super Administrator");
            },
            communityName() {
                return this.communityInfo ? this.communityInfo.name : "";
            },
            hasCommunityIdInRoute() {
                return !!this.$route.params.communityId;
            },
            isExistGroup() {
                return this.usersCommunitiesList && this.usersCommunitiesList.length > 0 && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId);
            },
            enrollmentType() {
                return (this.communityInfo && this.communityInfo.enrollmentMethod) ? this.communityInfo.enrollmentMethod : "Email Request";
            },
            communityCategory() {
                if (this.communityInfo) {
                    return this.communityInfo.category;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .group_banner {
        background: url(../../assets/ypo-banner.jpg);
        position: relative;
        min-height: 150px;
        background-size: cover;
        background-position: center;
        margin-top: 64px;

        @include breakpoint(xs) {
            margin-top: 125px !important;
        }

        &:before {
            content: '';
            background: rgba($ypo_blue, 0.5);
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .awards_block {
            position: absolute;
            right: 29px;
            top: 20px;
            z-index: 1;
            text-align: right;
            font-size: 12px;
            color: $white;
            font-family: 'Raleway', sans-serif;

            span {
                float: left;
                padding-top: 12px;
                font-size: 10px;
            }

            strong {
                display: block;
                font-size: 14px;
                font-weight: 500;
            }

            img {
                max-width: 28px;
                float: right;
                margin-left: 3px;
            }
        }

    }
</style>
